import React from "react";
import PropTypes from "prop-types";
// material ui core
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
// material ui icons
import RefreshIcon from "@material-ui/icons/Refresh";
import SendIcon from "@material-ui/icons/Send";
// Custom components
import { Dashboard as DashboardLayout } from "../../layouts/";
// Styles
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import QRCode from "qrcode.react";
import TooltipToggleButton from "../../components/Tooltip/tooltipToggleButtons";
import _ from "lodash";

import {
  setupTOTP,
  enterVerificationMFACode,
  verifyTotpToken,
  updateUserAttr,
  resendSMSVerificationCode,
  submitSMSVerificationCode
} from "../../redux/actions/profileScreenActions";
import { pushMessage, removeMessage } from "../../redux/actions/commonActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { store } from "../../index";
import { ENTER_VERIFICATION_MFA_CODE, SETUP_SMS } from "../../redux/actions/types";
import ChangePassword from "../../layouts/Dashboard/components/RightSidebar/ChangePasswordForm";
import { getUserDisplayName } from "../../utils";

const SMSIcon = require("@material-ui/icons/Textsms").default;
const PowerOffIcon = require("@material-ui/icons/PowerSettingsNew").default;
const TOTPIcon = require("@material-ui/icons/PhonelinkLock").default;

const useStyles = makeStyles(theme => ({
  toggleContainer: {
    margin: theme.spacing(2, 0)
  },
  textfield: {
    margin: "8px auto 8px auto",
    width: "150px"
  },
  form: {
    width: "100%",
    display: "block"
  },
  totpError: {
    paddingTop: "5px",
    color: "red"
  },
  totpInfo: {
    paddingTop: "5px",
    color: "blue"
  }
}));

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2)
  },
  textfield: {
    margin: "8px auto",
    width: "100%"
  },
  toolbar: {
    margin: "4px"
  },
  bigAvatar: {
    width: 100,
    height: 100,
    margin: "auto"
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "space-between",
    margin: theme.spacing(2, 0, 2, 0)
  }
});

class ProfileForm extends React.Component {
  state = {
    first_name: "",
    last_name: "",
    title: "",
    company_name: "",
    phone_number: "",
    nickname: "",
    mfaCode: "",
    smsVerificationCode: "",
    openChangePwdDialog: false,
    required: ["first_name", "last_name", "company_name", "smsVerificationCode"]
  };

  componentDidMount() {
    const given_name = this.props.cognitoUser.attributes.given_name;
    const last_name = this.props.cognitoUser.attributes.family_name;
    const title = _.get(this.props.cognitoUser.attributes, "custom:title");
    const company_name = _.get(this.props.cognitoUser.attributes, "custom:company_name");
    const phone_number = this.props.cognitoUser.attributes.phone_number;
    const nickname = this.props.cognitoUser.attributes.nickname;

    this.setState({
      first_name: given_name ? given_name : "",
      last_name: last_name ? last_name : "",
      title: title ? title : "",
      company_name: company_name ? company_name : "",
      phone_number: phone_number ? phone_number : "",
      nickname: nickname ? nickname : ""
    });

    const prederedMFA = _.get(this.props, "cognitoUser.preferredMFA", _.get(this.props, "cognitoUser.challengeName"));

    // remove code from redux store when component mount
    if (prederedMFA === "NOMFA") {
      store.dispatch(function(dispatch) {
        // ... which themselves may dispatch many times
        dispatch({ type: SETUP_SMS });
      });
    }
  }

  handleChange = e => {
    if (!e.target.value && !this.state.required.includes(e.target.id)) {
      this.setState({
        [e.target.id]: " "
      });
    } else {
      this.setState({
        [e.target.id]: e.target.value.trim()
      });
    }
  };

  handleUpdateUserAttributes = event => {
    event.preventDefault();
    const userAttributes = {
      given_name: this.state.first_name.trim(),
      family_name: this.state.last_name.trim(),
      "custom:company_name": this.state.company_name.trim()
    };
    let phoneChanged =
      (this.props.cognitoUser.attributes.phone_number === undefined
        ? ""
        : this.props.cognitoUser.attributes.phone_number) !== this.state.phone_number;
    console.log(this.props.cognitoUser.attributes.phone_number, this.state.phone_number);

    if (this.state.title) {
      userAttributes["custom:title"] = this.state.title.trim();
    }

    if (this.state.phone_number) {
      userAttributes.phone_number = this.state.phone_number.trim();
    }

    if (this.state.nickname) {
      userAttributes.nickname = this.state.nickname.trim();
    }

    this.props.updateUserAttr(this.props.cognitoUser, userAttributes, phoneChanged);
  };

  handleResendSMSCode = event => {
    event.preventDefault();

    this.props.resendSMSVerificationCode();
  };

  handleSubmitSMSCode = event => {
    event.preventDefault();
    if (!this.state.smsVerificationCode) {
      this.props.pushMessage({
        message: "Verification Code can't be empty",
        type: "info"
      });
      return;
    }

    this.props.submitSMSVerificationCode(this.state.smsVerificationCode.trim());
  };

  toggleChangePassword = e => {
    this.setState({
      openChangePwdDialog: !this.state.openChangePwdDialog
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <form onSubmit={this.handleUpdateUserAttributes}>
          <Grid item>
            <TextField
              required
              id="first_name"
              className={classes.textfield}
              variant="outlined"
              label="First Name"
              onChange={this.handleChange}
              value={this.state.first_name}
            />
            <TextField
              required
              id="last_name"
              className={classes.textfield}
              variant="outlined"
              label="Last Name"
              onChange={this.handleChange}
              value={this.state.last_name}
            />
            <TextField
              id="nickname"
              className={classes.textfield}
              variant="outlined"
              label="Community Nickname"
              onChange={this.handleChange}
              value={this.state.nickname}
            />
            <TextField
              id="title"
              className={classes.textfield}
              variant="outlined"
              label="Title"
              placeholder="Business Analyst"
              onChange={this.handleChange}
              value={this.state.title}
            />
            <TextField
              required
              id="company_name"
              className={classes.textfield}
              variant="outlined"
              label="Company Name"
              placeholder="Responsum"
              onChange={this.handleChange}
              value={this.state.company_name}
            />
            <TextField
              id="phone_number"
              className={classes.textfield}
              variant="outlined"
              label="Phone Number"
              placeholder="+1234567890"
              onChange={this.handleChange}
              value={this.state.phone_number}
            />
            {!this.props.cognitoUser.attributes.phone_number_verified &&
              this.props.cognitoUser.attributes.phone_number && (
                <Grid container>
                  <Grid item xs={6}>
                    <TextField
                      id="smsVerificationCode"
                      helperText="Phone number is not verified"
                      className={classes.textfield}
                      variant="outlined"
                      label="Verification Code"
                      onChange={this.handleChange}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Toolbar className={classes.toolbar}>
                      <Tooltip title="Send verification code">
                        <IconButton color="secondary" onClick={this.handleResendSMSCode}>
                          <RefreshIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Submit verification code">
                        <IconButton color="secondary" onClick={this.handleSubmitSMSCode}>
                          <SendIcon />
                        </IconButton>
                      </Tooltip>
                    </Toolbar>
                  </Grid>
                </Grid>
              )}
          </Grid>
          <div className={classes.buttonWrapper}>
            <Button type="submit" variant="contained" color="primary">
              Save
            </Button>
            <Button type="button" variant="contained" color="primary" onClick={this.toggleChangePassword}>
              Change Password
            </Button>
          </div>
        </form>
        <ChangePassword openDialog={this.state.openChangePwdDialog} toggleRightSidebar={this.toggleChangePassword} />
      </React.Fragment>
    );
  }
}

const handleVerificationMFA = componentProps => event => {
  event.preventDefault();
  componentProps.verifyTotpToken(componentProps.cognitoUser, componentProps.verificationCode);
};

const handleOnChangeMFAInput = e => {
  store.dispatch(function(dispatch) {
    // ... which themselves may dispatch many times
    dispatch({ type: ENTER_VERIFICATION_MFA_CODE, payload: e.target.value });
  });
};

const MFAToggle = componentProps => {
  const preferedMFA = _.get(
    componentProps,
    "cognitoUser.preferredMFA",
    _.get(componentProps, "cognitoUser.challengeName")
  );

  const [alignment, setAlignment] = React.useState(
    preferedMFA === "SOFTWARE_TOKEN_MFA" ? "TOTP" : preferedMFA === "SMS_MFA" ? "SMS" : preferedMFA
  );
  const [formats, setFormats] = React.useState(() => ["bold"]);

  const handleFormat = (event, newFormats) => {
    setFormats(newFormats);
  };

  const handleAlignment = (event, newAlignment) => {
    let { cognitoUser, pushMessage } = componentProps;
    if (
      newAlignment === "SMS" &&
      (!cognitoUser.attributes.phone_number || !cognitoUser.attributes.phone_number_verified)
    ) {
      pushMessage({
        message: "You must set and verify your phone number before you can use SMS text message for MFA.",
        type: "info"
      });
      return;
    }
    setAlignment(newAlignment);
    componentProps.setupTOTP(cognitoUser, newAlignment);
  };

  const classes = useStyles();

  const { TOTPCode, cognitoUser, errorMessage, infoMessage } = componentProps;

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Typography variant="h6" component="h3">
          Added Authentication
        </Typography>
        <Typography style={{ paddingTop: "10px" }}>
          Multi-factor authentication (MFA) increases security for your app by adding another authentication method, and
          not relying solely on user name and password. You can choose to use SMS text messages, or time-based one-time
          (TOTP) passwords as second factors in signing in your users.
        </Typography>
      </Grid>
      <Grid item xs={12} style={{ display: "flex", height: "80px" }}>
        <ToggleButtonGroup value={alignment} exclusive onChange={handleAlignment} style={{ margin: "auto" }}>
          <TooltipToggleButton value="NOMFA" title="NOMFA">
            <PowerOffIcon />
          </TooltipToggleButton>
          <TooltipToggleButton value="SMS" title="SMS">
            <SMSIcon />
          </TooltipToggleButton>
          <TooltipToggleButton value="TOTP" title="TOTP">
            <TOTPIcon />
          </TooltipToggleButton>
        </ToggleButtonGroup>
      </Grid>

      {TOTPCode && (
        <Grid item xs={12}>
          <Grid item xs={12} style={{ display: "flex", height: "150px" }}>
            <div style={{ margin: "auto" }}>
              <QRCode
                value={"otpauth://totp/" + cognitoUser.username + "?secret=" + TOTPCode + "&issuer=" + "VoiceHub.ai"}
              />
            </div>
          </Grid>
          <Grid item xs={12}>
            <form className={classes.form} onSubmit={handleVerificationMFA(componentProps)}>
              <div style={{ width: "100%", display: "flex" }}>
                <TextField
                  required
                  id="challengeAnswer"
                  className={classes.textfield}
                  variant="outlined"
                  label="Verification Code"
                  onChange={handleOnChangeMFAInput}
                  autoComplete="off"
                />
              </div>
              <div style={{ width: "100%", display: "flex" }}>
                <Button type="submit" variant="contained" color="primary" style={{ margin: "auto 0px auto auto" }}>
                  SUBMIT
                </Button>
              </div>
            </form>
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
};

class Profile extends React.Component {
  state = {
    isLoading: true,
    openDialog: false
  };

  render() {
    const { classes } = this.props;
    return (
      <DashboardLayout title="Profile">
        <Grid container spacing={5}>
          <Grid item lg={3}>
            <Paper className={classes.root} elevation={1}>
              <Avatar
                alt={getUserDisplayName(this.props.cognitoUser)}
                src={_.get(
                  this.props.cognitoUser.attributes,
                  "picture",
                  "https://cdn.pixabay.com/photo/2016/04/01/11/25/avatar-1300331_960_720.png"
                )}
                className={classes.bigAvatar}
              />
            </Paper>
          </Grid>
          <Grid item lg={5}>
            <Paper className={classes.root} elevation={1}>
              <ProfileForm classes={classes} {...this.props} />
            </Paper>
          </Grid>
          <Grid item lg={4}>
            <Paper className={classes.root} elevation={1}>
              <MFAToggle {...this.props} />
            </Paper>
          </Grid>
        </Grid>
      </DashboardLayout>
    );
  }
}

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
  cognitoUser: PropTypes.object,
  TOTPCode: PropTypes.string,
  verificationCode: PropTypes.string,
  message: PropTypes.object
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    TOTPCode: state.profile.code,
    verificationCode: state.profile.verificationCode,
    message: state.common.message
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        setupTOTP,
        enterVerificationMFACode,
        verifyTotpToken,
        updateUserAttr,
        removeMessage,
        resendSMSVerificationCode,
        submitSMSVerificationCode,
        pushMessage
      },
      dispatch
    ),
    dispatch
  };
}

Profile = connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile);

export default withStyles(styles)(Profile);
